var _styled;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

// https://github.com/alphagov/govuk_frontend_toolkit/blob/master/stylesheets/_grid_layout.scss
// https://github.com/alphagov/govuk_elements/blob/master/assets/sass/elements/_layout.scss
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { GUTTER_HALF, MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var StyledColumn = styled('div')((_styled = {
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  margin: 0,
  marginBottom: SPACING.SCALE_3,
  textIndent: '0',
  boxSizing: 'border-box'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  width: '100%',
  margin: "0 " + GUTTER_HALF,
  ':first-child': {
    marginLeft: 0
  },
  ':last-child': {
    marginRight: 0
  }
}, _styled), function (_ref) {
  var hideContent = _ref.hideContent;
  return {
    textIndent: hideContent ? '-999em' : undefined,
    backgroundColor: hideContent ? '#7DADD3' : undefined,
    backgroundImage: hideContent ? 'repeating-linear-gradient(180deg, #7DADD3, #7DADD3 15px, #B7CFE1 15px, #B7CFE1 30px)' : undefined
  };
}, function (_ref2) {
  var _ref3;

  var columnOneThird = _ref2.columnOneThird;
  return _ref3 = {}, _ref3[MEDIA_QUERIES.LARGESCREEN] = {
    width: columnOneThird ? '33.3333%' : undefined
  }, _ref3;
}, function (_ref4) {
  var _ref5;

  var columnTwoThirds = _ref4.columnTwoThirds;
  return _ref5 = {}, _ref5[MEDIA_QUERIES.LARGESCREEN] = {
    width: columnTwoThirds ? '66.6667%' : undefined
  }, _ref5;
}, function (_ref6) {
  var _ref7;

  var columnOneQuarter = _ref6.columnOneQuarter;
  return _ref7 = {}, _ref7[MEDIA_QUERIES.LARGESCREEN] = {
    width: columnOneQuarter ? '50%' : undefined
  }, _ref7;
});

var GridCol = function GridCol(_ref8) {
  var children = _ref8.children,
      props = _objectWithoutProperties(_ref8, ["children"]);

  return React.createElement(StyledColumn, props, children);
};

GridCol.defaultProps = {
  children: undefined
};
GridCol.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default GridCol;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/grid-col/es/index.js
// module id = 80
// module chunks = 0